import axios from 'axios';

const { REACT_APP_API_URL: API_URL } = process.env;

export const addEmailToNewsletter = async (email: string) => {
  const { data } = await axios.post(`${API_URL}/newsletter`, { email });
  return data;
};